





























































































































































































































































































































































































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import Api from "@/api";
import swal from "sweetalert";
import FormErrorsMixin from "@/mixins/FormErrors";
import { AxiosResponse } from "axios";

import NavigationTabs from "@/components/Settings/Events/EventDetails/NavigationTabs.vue";
import ViewLoader from "@/components/Common/ViewLoader.vue";
import AlertBox from "@/components/Common/Alerts/AlertBox.vue";
import TextInput from "@/components/Common/Inputs/TextInput.vue";
import InfoButton from "@/components/Common/Buttons/InfoButton.vue";
import SuccessButton from "@/components/Common/Buttons/SuccessButton.vue";
import Error404 from "@/components/Common/Error404.vue";
import { EventPriceForm, IEvent, IEventPrice, IVat } from "@/interface";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    ViewLoader,
    NavigationTabs,
    TextInput,
    InfoButton,
    SuccessButton,
    AlertBox,
    Error404
  }
})
export default class EventPrices extends Mixins(FormErrorsMixin) {
  public loading = false;
  public updating = false;
  public validatedInputs = ["form", "vat", "amount"];
  private eventPrices: Array<IEventPrice> = [];
  private noDataExist = false;
  private defaultPriceLoading = false;
  private eventLoading = false;
  private eventPricesLength = 0;
  private defaultPrice: IEventPrice = {
    name: "Default",
    form: EventPriceForm.GROSS,
    usable_online: false,
    vat_id: 1,
    amount: 0
  };
  private availableVats: Array<IVat> | null = null;
  private isFreebie = false;
  private failedRequest = false;
  private currentPage = 1;
  private total = 0;
  private from = 0;
  private to = 0;
  private firstPage = 1;
  private lastPage: number | null = null;
  private perPage = 20;
  private selectedEvent: IEvent | null = null;
  private selectedEventId: string | null = null;
  private componentKey = 0;

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.selectedEventId = vm.$route.params.event_id;

      if (vm.$route.query.event_price_deleted === "true") {
        swal("Success!", "The price was deleted.", "success").then(() => {
          window.history.pushState(
            {},
            document.title,
            window.location.pathname
          );
        });
      }
      vm.getEventPrices(() => {
        //
      });
      vm.getEvent(() => {
        //
      });
      vm.getDefaultPrice(() => {
        //
      });
      vm.getVats(() => {
        //
      });
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    if (to.query.event_price_deleted === "true") {
      swal("Success!", "The price was deleted.", "success").then(() => {
        window.history.pushState({}, document.title, window.location.pathname);
      });
    }
    this.forceRerender();
    if (this.to % this.perPage === 1 && this.currentPage !== 1) {
      this.currentPage -= 1;
    }
    this.getEventPrices(() => {
      //
    });
    this.getEvent(() => {
      //
    });
    this.getDefaultPrice(() => {
      //
    });
    this.getVats(() => {
      //
    });
    next();
  }

  private createOrUpdatePrice(): void {
    if (!this.defaultPrice.id) {
      this.createEventPrice();
    } else {
      this.updateEventPrice();
    }
  }

  private getEvent(successCallback?: any): void {
    this.resetErrors();
    this.eventLoading = true;
    const endpoint: string = this.$partnerEndpoint(
      "events/" + this.selectedEventId
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.selectedEvent = response.data.data;
        this.isFreebie = response.data.data.freebie;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        console.log(error.response);
      })
      .finally(() => {
        this.eventLoading = false;
      });
  }

  private getEventPrices(successCallback?: any): void {
    if (this.loading) {
      return;
    }

    this.loading = true;
    this.eventPrices = [];
    const endpoint: string = this.$partnerEndpoint(
      "events/" + this.selectedEventId + "/prices"
    );

    Api()
      .get(endpoint, {
        params: { page: this.currentPage, perPage: this.perPage }
      })
      .then((response: AxiosResponse) => {
        this.eventPrices = response.data.data;
        this.currentPage = response.data.meta.current_page;
        this.total = response.data.meta.total;
        if (response.data.meta.from != null) {
          this.from = response.data.meta.from;
        } else {
          this.from = 0;
        }
        if (response.data.meta.to != null) {
          this.to = response.data.meta.to;
        } else {
          this.to = 0;
        }
        this.lastPage = response.data.meta.last_page;
        this.perPage = response.data.meta.per_page;
        this.eventPricesLength = this.eventPrices.length;
        this.failedRequest = false;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch(() => {
        this.failedRequest = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private deleteEventPrice(priceId: number): void {
    if (this.loading || this.updating || priceId == null) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: "The price will be deleted and will not be able to use it",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        const endpoint: string = this.$partnerEndpoint(
          "events/" + this.selectedEventId + "/prices/" + priceId
        );

        Api()
          .delete(endpoint)
          .then(() => {
            this.$router
              .push({
                name: "EventPrices",
                query: { event_price_deleted: "true" }
              })
              .catch((error: any) => {
                console.log(error);
                if (
                  error.name === "NavigationDuplicated" ||
                  error.message.includes(
                    "Avoided redundant navigation to current location"
                  )
                ) {
                  swal("Success!", "The price was deleted.", "success");
                  this.getEventPrices(() => {
                    //
                  });
                }
              });
          })
          .catch((error: any) => {
            if (error.response.status === 403) {
              swal({
                title: "Missing permission",
                text: "You are not allowed to delete event prices.",
                icon: "error"
                //dangerMode: true,
              });
            }
          });
      } else {
        //
      }
    });
  }

  private createEventPrice(): void {
    if (this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint(
      "events/" + this.selectedEventId + "/prices"
    );

    Api()
      .post(endpoint, this.defaultPrice)
      .then(() => {
        this.getDefaultPrice();
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private updateEventPrice(): void {
    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint(
      "events/" + this.selectedEventId + "/prices/" + this.defaultPrice.id
    );

    Api()
      .put(endpoint, this.defaultPrice)
      .then(() => {
        this.getDefaultPrice();
      })
      .catch((error: any) => {
        console.log(error);
        this.storeErrors(error.response.data.errors);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private getDefaultPrice(successCallback?: any): void {
    this.resetErrors();
    this.defaultPriceLoading = true;
    const endpoint: string = this.$partnerEndpoint(
      "events/" + this.selectedEventId + "/prices/default"
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.defaultPrice.id = response.data.data.id;
        this.defaultPrice.name = response.data.data.name;
        this.defaultPrice.description = response.data.data.description;
        this.defaultPrice.type = response.data.data.type;
        this.defaultPrice.usable_online = response.data.data.usable_online;
        this.defaultPrice.form = response.data.data.form;
        this.defaultPrice.amount =
          response.data.data.form === "net"
            ? response.data.data.amount_net
            : response.data.data.amount_gross;
        this.defaultPrice.vat_id = response.data.data.vat.id;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => {
        this.defaultPriceLoading = false;
      });
  }

  private getVats(successCallback?: any): void {
    this.resetErrors();
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint("vats");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.availableVats = response.data.data;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private toggleEventFreebie(): void {
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint(
      "events/" + this.selectedEventId + "/freebie"
    );

    Api()
      .put(endpoint)
      .then(() => {
        this.getEvent();
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private goToFirstPage(): void {
    if (!this.disabledFirstPage) {
      this.currentPage = 1;
      this.getEventPrices(() => {
        //
      });
    }
  }

  private goToPreviousPage(): void {
    if (!this.disabledPreviousPage) {
      this.currentPage--;
      this.getEventPrices(() => {
        //
      });
    }
  }

  private goToNextPage(): void {
    if (!this.disabledNextPage) {
      this.currentPage++;
      this.getEventPrices(() => {
        //
      });
    }
  }

  private goToLastPage(): void {
    if (!this.disabledLastPage) {
      if (this.lastPage) {
        this.currentPage = this.lastPage;
      }
      this.getEventPrices(() => {
        //
      });
    }
  }

  private forceRerender(): void {
    this.componentKey += 1;
  }

  get disabledFirstPage(): boolean {
    return this.currentPage === 1;
  }

  get disabledPreviousPage(): boolean {
    return this.currentPage === 1;
  }

  get disabledNextPage(): boolean {
    return this.currentPage === this.lastPage;
  }

  get disabledLastPage(): boolean {
    return this.currentPage === this.lastPage;
  }

  @Watch("perPage")
  perPageChanged(): void {
    this.getEventPrices();
  }
}
